import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ProjectDetailsStateService } from '../../services/project-details-state.service';

@Component({
  selector: 'app-project-header-card',
  templateUrl: './project-header-card.component.html',
  styleUrls: ['./project-header-card.component.scss']
})
export class ProjectHeaderCardComponent implements OnInit, OnDestroy {
  @Input() selectedClient: string = '';
  @Input() selectedProject: string = '';

  private subs: Subscription = new Subscription();

  constructor(private stateService: ProjectDetailsStateService) {}

  ngOnInit(): void {
    if (!this.selectedClient) {
      this.subs.add(
        this.stateService.selectedClient$.subscribe(client => {
          this.selectedClient = client;
        })
      );
    }
    if (!this.selectedProject) {
      this.subs.add(
        this.stateService.selectedProject$.subscribe(project => {
          this.selectedProject = project;
        })
      );
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}

